<template>
  <form @submit.prevent="submit">
    <div class="row">
      <div v-if="$schema.showCurrentPassword.$model" class="form-group col-12">
        <w-input type="password" :model="$schema.currentPassword" :title="$t($schema.currentPassword.$schema.title)" />
      </div>

      <div class="form-group col-12">
        <w-input type="password" :model="$schema.password" :title="$t($schema.password.$schema.title)" />
      </div>

      <div class="form-group col-12">
        <w-input type="password" :model="$schema.repeat" :title="$t($schema.repeat.$schema.title)" />
      </div>

      <slot />

      <div class="col-12">
        <button type="submit" class="btn btn-danger float-right">{{ $t(buttonText) }}</button>
      </div>
    </div>
  </form>
</template>

<script>
import { formMixin } from '@/mixins/form';
import schema from '@/schemas/password.schema';
import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Formularz haseł
// @group Start
export default {
  name: 'PasswordForm',
  mixins: [formMixin, notificationsMixin],
  props: {
    // Tekst przycisku
    buttonText: {
      type: String,
      required: false,
      default: 'buttons.save'
    },
    // Czy pytać o obecne hasło
    currentPassword: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      model: {
        password: '',
        repeat: ''
      }
    };
  },
  schema,
  methods: {
    // @vuese
    // Ustawia wpisane hasło
    submit() {
      if (!this.$schema.$validateAll().length) {
        this.$emit('setPassword', this.$schema.$getData());
      }
    }
  },
  mounted() {
    this.$schema.showCurrentPassword.$setData(this.currentPassword);
  }
};
</script>
